export const TOP_VHP_BANNER = 'topVhpBanner';
export const BOTTOM_VHP_BANNER = 'bottomVhpBanner';
export const TOP_MHP_BANNER = 'topMhpBanner';
export const BOTTOM_MHP_BANNER = 'bottomMhpBanner';
